export const config = {
  baseUrl: process.env.REACT_APP_BASE_URL || 'https://localhost:3000', 
  baseTableauUrl: process.env.REACT_APP_BASE_TABLEAU_URL || 'http://tableau.pshdemo.com',
  timeout: 20000, //not used in code
  https: process.env.HTTPS || false, //not used in code
  gTagID: process.env.REACT_APP_GTAG_ID || 'GTM-WK5H8ZLK,G-PFQYED70LM',
  publicFeedback: true
  //Local/Dev/Test: GTM-WK5H8ZLK
  //Prod: GTM-W85XVGBB
};
